import React, {useEffect, useMemo, useState} from "react";

import CoverPreview from "./CoverPreview";
import styles from "./CoverPreviewContainer.module.scss";
import uploadImageTrans from "src/assets/png/uploadImageTrans.png";
import Lightbox from "react-image-lightbox";
import "react-image-lightbox/style.css";
import {Modal} from "antd";
import ReactPlayer from "react-player";

const rotation = {
  horizontal: "horizontal",
  vertical: "vertical",
  default: "default",
};

const CoverPreviewContainer = (props: any) => {
  const { previewCovers, handleCloseCover } = props;

  const [isOpen, setIsOpen] = useState(false);
  const [photoIndex, setPhotoIndex] = useState(0);
  const [currentImg, setCurrentImg] = useState(true);
  const [openType, setOpenType]: any = useState(null);

  useEffect(() => {
      console.log("previewCovers", previewCovers)
  }, [previewCovers])


  useEffect (()=>{
      try {
          //let split_url = previewCovers[photoIndex].coverLink;
          let file_ = "FileCacheService";
          console.log(file_.includes("FileService"));
          if (file_.includes("FileService")) {
              setCurrentImg(true)
          } else {
              setCurrentImg(false)
          }
      } catch (e) {
          console.log(e);
      }
    // let split_url = previewCovers[photoIndex].coverLink;
    let file_ = "FileCacheService";
    console.log(file_.includes("FileService"));
    if(file_.includes("FileService")) {
      setCurrentImg(true)
    }else{
      setCurrentImg(false)
    }
  },[])

  const handleOpenFullImage = (type: string, coverIdx: number) => {
    setIsOpen(true);
    setOpenType(type);
    setPhotoIndex(coverIdx);
  };

  const renderPreviewImages = useMemo(() => {
    const coverCount = previewCovers?.length;
    if (coverCount === 1) {
      return (
        <div>
          <div className={styles.coverPreviewWrapper}
            style={{ width: "100%", margin: "auto" }}>
            <CoverPreview
              id={previewCovers[0]?.id}
              onClick={() => {
                handleOpenFullImage(previewCovers[0]?.coverType, 0);
              }}
              close={props.editable}
              coverUrl={previewCovers[0]?.coverLink}
              coverType={previewCovers[0]?.coverType}
              handleCloseCover={handleCloseCover}
              width="100%"
              height="300px"
              backgroundSize="contain"
            />
          </div>
        </div>
      );
    } else if (coverCount === 2) {
      const isVertical = previewCovers[0]?.rotation == rotation.vertical;
      return (
        <div
          style={{
            display: isVertical ? "inline-flex" : "block",
            justifyContent: isVertical ? "" : "space-between",
            width: "100%",
            height: "auto",
            gap: isVertical ? "2%" : "0",
          }}
        >
          {previewCovers.map((cover: any, idx: number) => {
            return (
              <div
                className={styles.coverPreviewWrapper}
                style={{ width: "100%", margin: isVertical ? "" : "0 0 10px 0" }}
              >
                <CoverPreview
                  key={idx}
                  id={previewCovers[idx]?.id}
                  onClick={() => {
                    handleOpenFullImage(previewCovers[idx]?.coverType, idx);
                  }}
                  close={props.editable}
                  coverUrl={cover?.coverLink}
                  coverType={cover?.coverType}
                  handleCloseCover={handleCloseCover}
                  width={isVertical ? "20em" : "20em"}
                  height={isVertical ? "300px" : "200px"}
                  margin={"auto"}
                />
              </div>
            );
          })}
        </div>
      );
    } else if (coverCount === 3) {
      return (
        <div style={{ display: "inline-flex", width: "100%", height: "auto" }}>
          <div
            className={styles.coverPreviewWrapper}
            style={{ width: "40%" }}
          >
            <CoverPreview
              onClick={() => {
                handleOpenFullImage(previewCovers[0]?.coverType, 0);
              }}
              close={props.editable}
              coverUrl={previewCovers[0]?.coverLink}
              coverType={previewCovers[0]?.coverType}
              handleCloseCover={handleCloseCover}
              width="100%"
              height="410px"
              id={previewCovers[0]?.imageID}
            />
          </div>

          <div style={{ width: "68%", marginLeft: "2%", display: "block" }}>
            <div
              className={styles.coverPreviewWrapper}
              style={{ margin: "0 0 10px 0" }}
            >
              <CoverPreview
                onClick={() => {
                  handleOpenFullImage(previewCovers[1]?.coverType, 1);
                }}
                close={props.editable}
                coverUrl={previewCovers[1]?.coverLink}
                coverType={previewCovers[1]?.coverType}
                handleCloseCover={handleCloseCover}
                width="100%"
                height="200px"
                id={previewCovers[1]?.imageID}
              />
            </div>
            <div className={styles.coverPreviewWrapper}>
              <CoverPreview
                onClick={() => {
                  handleOpenFullImage(previewCovers[2]?.coverType, 2);
                }}
                close={props.editable}
                coverUrl={previewCovers[2]?.coverLink}
                coverType={previewCovers[2]?.coverType}
                handleCloseCover={handleCloseCover}
                width="100%"
                height="200px"
                id={previewCovers[2]?.imageID}
              />
            </div>
          </div>
        </div>
      );
    } else if (coverCount === 4 || coverCount > 4) {
      const isVertical = previewCovers[0]?.rotation == rotation.vertical;
      const moreThanFour = coverCount > 4;

      if (isVertical) {
        return (
          <div
            style={{ display: "inline-flex", width: "100%", height: "auto" }}
          >
            <div style={{ width: "30%", display: "block" }}>
              <div className={styles.coverPreviewWrapper}>
                <CoverPreview
                  onClick={() => {
                    handleOpenFullImage(previewCovers[0]?.coverType, 0);
                  }}
                  close={props.editable}
                  coverUrl={previewCovers[0]?.coverLink}
                  coverType={previewCovers[0]?.coverType}
                  handleCloseCover={handleCloseCover}
                  width="100%"
                  height="300px"
                  id={previewCovers[0]?.imageID}
                />
              </div>
            </div>

            <div style={{ width: "68%", marginLeft: "2%", display: "block" }}>
              <div className={styles.coverPreviewWrapper}
                style={{ width: "100%", margin: "0 0 10px 0" }}
              >
                <CoverPreview
                  onClick={() => {
                    handleOpenFullImage(previewCovers[1]?.coverType, 1);
                  }}
                  close={props.editable}
                  coverUrl={previewCovers[1]?.coverLink}
                  coverType={previewCovers[1]?.coverType}
                  handleCloseCover={handleCloseCover}
                  width="100%"
                  height="200px"
                  id={previewCovers[1]?.imageID}
                />
              </div>

              <div
                style={{
                  display: "inline-flex",
                  width: "100%",
                  gap: "2%",
                  height: "auto",
                  justifyContent: "space-between",
                }}
              >
                <div className={styles.coverPreviewWrapper}
                  style={{ width: "100%", margin: "0 0 10px 0" }}
                >
                  <CoverPreview
                    onClick={() => {
                      handleOpenFullImage(previewCovers[2]?.coverType, 2);
                    }}
                    close={props.editable}
                    coverUrl={previewCovers[2]?.coverLink}
                    coverType={previewCovers[2]?.coverType}
                    handleCloseCover={handleCloseCover}
                    width="100%"
                    height="200px"
                    id={previewCovers[2]?.imageID}
                  />
                </div>
                <div className={styles.coverPreviewWrapper}
                  style={{ width: "100%", margin: "0 0 10px 0" }}
                >
                  <CoverPreview
                    onClick={() => {
                      handleOpenFullImage(previewCovers[3]?.coverType, 3);
                    }}
                    close={props.editable}
                    coverUrl={previewCovers[3]?.coverLink}
                    coverType={previewCovers[3]?.coverType}
                    handleCloseCover={handleCloseCover}
                    width="100%"
                    height="200px"
                    id={previewCovers[3]?.imageID}
                    more={moreThanFour ? previewCovers?.length - 4 : null}
                  />
                </div>
              </div>
            </div>
          </div>
        );
      } else {
        return (
          <div style={{ display: "block", width: "100%", height: "auto" }}>
            <div
              style={{
                display: "inline-flex",
                width: "100%",
                height: "auto",
                marginBottom: 10,
                gap: "2%",
                justifyContent: "space-between",
              }}
            >
              <div
                className={styles.coverPreviewWrapper}
                style={{ width: "68%" }}
              >
                <CoverPreview
                  id={previewCovers[0]?.id}
                  onClick={() => {
                    handleOpenFullImage(previewCovers[0]?.coverType, 0);
                  }}
                  close={props.editable}
                  coverUrl={previewCovers[0]?.coverLink}
                  coverType={previewCovers[0]?.coverType}
                  handleCloseCover={handleCloseCover}
                  width="100%"
                  height="200px"
                />
              </div>

              <div
                className={styles.coverPreviewWrapper}
                style={{ width: "30%" }}
              >
                <CoverPreview
                  id={previewCovers[1]?.id}
                  onClick={() => {
                    handleOpenFullImage(previewCovers[1]?.coverType, 1);
                  }}
                  close={props.editable}
                  coverUrl={previewCovers[1]?.coverLink}
                  coverType={previewCovers[1]?.coverType}
                  handleCloseCover={handleCloseCover}
                  width="100%"
                  height="200px"
                />
              </div>
            </div>

            <div
              style={{
                display: "inline-flex",
                width: "100%",
                height: "auto",
                gap: "2%",
                justifyContent: "space-between",
              }}
            >
              <div
                className={styles.coverPreviewWrapper}
                style={{ width: "30%" }}
              >
                <CoverPreview
                  id={previewCovers[2]?.id}
                  onClick={() => {
                    handleOpenFullImage(previewCovers[2]?.coverType, 2);
                  }}
                  close={props.editable}
                  coverUrl={previewCovers[2]?.coverLink}
                  coverType={previewCovers[2]?.coverType}
                  handleCloseCover={handleCloseCover}
                  width="100%"
                  height="200px"
                />
              </div>

              <div
                className={styles.coverPreviewWrapper}
                style={{ width: "68%" }}
              >
                <CoverPreview
                  onClick={() => {
                    handleOpenFullImage(previewCovers[3]?.coverType, 3);
                  }}
                  close={props.editable}
                  coverUrl={previewCovers[3]?.coverLink}
                  coverType={previewCovers[3]?.coverType}
                  handleCloseCover={handleCloseCover}
                  width="100%"
                  height="200px"
                  more={moreThanFour ? previewCovers?.length - 4 : null}
                />
              </div>

            </div>
          </div>
        );
      }
    }
  }, [previewCovers, props.editable, props.new, props.canMoreImage]);

  return (
    <>
      {props.new ? (
        <>
          <div
            className={styles.coverContainer}
            style={{
              // marginLeft: props.editable ? 0 : 15,
              marginBottom: "1.5rem",
              // position: "relative",
              // height: props.editable ? 300 : "auto",
              // overflowY: "scroll",
              // marginRight: props.editable ? 0 : 5,
            }}
          >
            {renderPreviewImages}
            {props?.canMoreImage && props?.editable && (
              <>
                <div
                  className={styles.moreImageBtn}
                  style={{ backgroundImage: `url(${uploadImageTrans})` }}
                  onClick={props?.onAddImage}
                ></div>

                {previewCovers.length > 4 && (
                  <div>Below image will not display in a real post.</div>
                )}
                {previewCovers.length > 4 && (
                  <div className={styles.cardCoverPreview}>
                    {previewCovers.slice(4).map((cover: any, idx: number) => {
                        return (
                            <CoverPreview
                                onClick={() => { }}
                                close={props.editable}
                                coverUrl={cover.coverLink}
                                coverType={cover.coverType}
                                handleCloseCover={handleCloseCover(cover.coverLink)}
                            />
                        );
                    })}
                  </div>
                )}
              </>
            )}
          </div>

          {isOpen && openType === "image" && (
            <Lightbox
              wrapperClassName={styles.lightboxOverride}
              mainSrc={ 
                currentImg
                ? previewCovers[photoIndex].coverLink + "&size=1024" 
                : previewCovers[photoIndex].coverLink
               } 
              nextSrc={
                photoIndex < previewCovers.length - 1
                  ? previewCovers[photoIndex + 1].coverLink 
                  : undefined
              }
              prevSrc={
                photoIndex !== 0
                  ? previewCovers[photoIndex - 1].coverLink 
                  : undefined
              }
              onCloseRequest={() => setIsOpen(false)}
              onMovePrevRequest={() => setPhotoIndex(photoIndex - 1)}
              onMoveNextRequest={() => setPhotoIndex(photoIndex + 1)}
              reactModalStyle={{backgroundColor:"#fff"}}
            />
          )}

          {isOpen && openType === "video" && (
            <Modal
              centered
              className={styles.modalOveride}
              visible={true}
              footer={null}
              onCancel={() => setIsOpen(false)}
            >
              <div
                style={{ width: "100%" }}
              // onClick={handleClickVideoModal}
              >
                <ReactPlayer
                  // onReady={videAudioOnReady}
                  controls={true}
                  className={styles.reactPlayer}
                  url={previewCovers[photoIndex].coverLink}
                />
              </div>
            </Modal>
          )}
        </>
      ) : (
        <div style={{ position: "relative" }}>
          <div className={styles.cardCoverPreview}>{props.children}</div>
          {props?.canMoreImage && (
            <div
              className={styles.moreImageBtn}
              style={{ backgroundImage: `url(${uploadImageTrans})` }}
              onClick={props?.onAddImage}
            ></div>
          )}
        </div>
      )}
    </>
  );
};

export default CoverPreviewContainer;
